import Link from "next/link";
import React, { Fragment, useEffect } from "react";

const tabs = [
  {
    text: "Blood",
    isActive: true,
    tab: "notes-tab-4",
    target: "notes-4",
    controls: "notes",
    desc: "Take notes in the textarea below.",
  },
  {
    text: "Hematology",
    isActive: false,
    tab: "download-tab-4",
    target: "download-4",
    controls: "download",
    desc: "",
  },
  {
    text: "Urine",
    isActive: false,
    tab: "doubts-tab-4",
    target: "doubts-4",
    controls: "doubts",
    desc: "Submit your doubts here.",
  },
];
const ExtraModals = ({
  handleNextQuestion,
  markedQuestions,
  handlePrevQuestion,
  selectedQuestion,
  handleMarkQuestion,
  openModal,
  timeLeft,
  unansweredCount,
  handleConfirmEndTest,
  openNotepad,
  closeNotepad,
}) => {
  useEffect(() => {
    const handleKeyPress = (event) => {
      const activeElement = document.activeElement;
      const activeTag = activeElement?.tagName?.toLowerCase();
      if (activeTag === "input" || activeTag === "textarea" || activeElement?.isContentEditable) {
        return;
      }

      const questionId = selectedQuestion?._id;

      switch (event.key) {
        case "m":
          if (questionId) {
            handleMarkQuestion(questionId);
          }
          break;
        case "n":
          openNotepad();
          break;
        case "l":
          openModal("labValues");
          break;
        case "/":
          openModal("shortCutModal");
          break;
        case "ArrowRight":
          handleNextQuestion();
          break;
        case "ArrowLeft":
          handlePrevQuestion();
          break;
        case "Escape":
          closeNotepad();
          break;
        default:
          break;
      }
    };

    window.addEventListener("keydown", handleKeyPress);

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
    };
  }, [
    closeNotepad,
    handleMarkQuestion,
    handleNextQuestion,
    handlePrevQuestion,
    openModal,
    openNotepad,
    selectedQuestion,
  ]);

  return (
    <Fragment>
      <div
        className="modal fade"
        id="preventReload"
        tabIndex="-1"
        aria-labelledby="preventReloadLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="modal-overlay">
                <div className="modal-header">
                  <h4 className="text-danger">
                    Reload Alert
                    <i className="ms-2 feather-alert-triangle"></i>
                  </h4>
                </div>
                <div className="modal-body">
                  <p>
                    Reloading the page can cause significant time delays and
                    lead to the loss of your current progress, including
                    incomplete or unsaved answers. This action will also
                    negatively impact the overall performance and experience.
                  </p>
                </div>
              </div>
            </div>
            <div className="top-circle-shape"></div>
            <div className="modal-footer pt--30">
              <button
                type="button"
                className="rbt-btn btn-border btn-sm radius-round-10"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="tabSwitch"
        tabIndex="-1"
        aria-labelledby="tabSwitchLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="modal-overlay">
                <div className="modal-header">
                  <h4 className="text-danger">
                    Alert <i className="feather-alert-triangle"></i>
                  </h4>
                </div>
                <div className="modal-body">
                  <p>
                    You are not allowed to switch tabs between the test. We will
                    monitor this behavior and will be impacted on your
                    performance
                  </p>
                </div>
              </div>
            </div>
            <div className="top-circle-shape"></div>
            <div className="modal-footer pt--30">
              <button
                type="button"
                className="rbt-btn btn-border btn-sm radius-round-10"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="endTestModal"
        tabIndex="-1"
        aria-labelledby="endTestModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="modal-overlay">
                <div className="modal-header">
                  <h4 className="text-danger">End Test Confirmation</h4>
                </div>
                <div className="modal-body">
                  <p>
                    You have {unansweredCount} unanswered question(s). Are you
                    sure you want to end the test anyway?
                  </p>
                </div>
              </div>
            </div>
            <div className="top-circle-shape"></div>
            <div className="modal-footer pt--30">
              <button
                type="button"
                className="rbt-btn btn-border btn-sm radius-round-10"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="rbt-btn btn-danger btn-sm radius-round-10"
                onClick={handleConfirmEndTest}
              >
                End Test
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="labValues"
        tabIndex="-1"
        aria-labelledby="labValuesLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="modal-overlay">
                <div className="modal-header">
                  <h4>Lab Values</h4>
                </div>

                <div className="advance-tab-button">
                  <ul
                    className="nav nav-tabs tab-button-style-2"
                    id="myTab-4"
                    role="tablist"
                  >
                    {tabs.map((item, innerIndex) => (
                      <li role="presentation" key={innerIndex}>
                        <Link
                          href="#"
                          className={`tab-button ${
                            item.isActive ? "active" : ""
                          }`}
                          id={item.tab}
                          data-bs-toggle="tab"
                          data-bs-target={`#${item.target}`}
                          role="tab"
                          aria-controls={item.target}
                          aria-selected={item.isActive}
                        >
                          <span className="title">{item.text}</span>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="rbt-dashboard-table table-responsive mobile-table-750 mt--30">
                  <table className="rbt-table table table-borderless">
                    <thead>
                      <tr>
                        <th>Blood</th>
                        <th>Urine</th>
                        <th>Sweet</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th>
                          <span className="h6 mb--5">Demo Item</span>
                        </th>
                        <th>
                          <span className="h6 mb--5">10 %</span>
                        </th>
                        <td>
                          <span className="h6 mb--5">10 %</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            <div className="top-circle-shape"></div>
            <div className="modal-footer pt--30">
              <button type="submit" className="rbt-btn btn-sm">
                Submit
              </button>
              <button
                type="button"
                className="rbt-btn btn-border btn-sm radius-round-10"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="shortCutModal"
        tabIndex="-1"
        aria-labelledby="shortCutModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body">
              <div className="modal-overlay">
                <div className="modal-header">
                  <h4>Shortcut Guide</h4>
                </div>
                <ul>
                  <li>
                    <strong>M</strong>: Mark / Unmark Question
                  </li>
                  <li>
                    <strong>Arrow Left</strong>: Previous Question
                  </li>
                  <li>
                    <strong>Arrow Right</strong>: Next Question
                  </li>
                  <li>
                    <strong>l</strong>: Open Lab Values Popup
                  </li>
                  <li>
                    <strong>N</strong>: Open Notes Notepad
                  </li>
                  <li>
                    <strong>/</strong>: Open Shortcut Popup
                  </li>
                  <li>
                    <strong>Esc</strong>: Close Notepad or Popup
                  </li>
                </ul>
              </div>
            </div>
            <div className="top-circle-shape"></div>
            <div className="modal-footer pt--30">
              <button type="submit" className="rbt-btn btn-sm">
                Submit
              </button>
              <button
                type="button"
                className="rbt-btn btn-border btn-sm radius-round-10"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>


    </Fragment>
  );
};

export default ExtraModals;
